export interface GalleryItem {
  label: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    label: 'Mesas rebatibles',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/452af39e-e19d-4e55-ab30-d5741cafefa8.jpg',
  },
  {
    label: 'Escritorios plegables',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6dcf2faa-774b-4efd-9e87-0ae5081703e4.jpg',
  },
  {
    label: 'Estanterías móviles',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8c33cba7-7b7f-4745-92f0-d091daa5242e.jpg',
  },
  {
    label: 'Islas funcionales',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6be8b901-fb91-4fd8-ad2a-2f609edab4a9.jpg',
  },
  {
    label: 'Dormitorios inteligentes',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/197fb501-3586-4b68-a0d1-453f7a81be55.jpg',
  },
  {
    label: 'Sillas y bancos plegables',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e63d8da3-3c07-4e76-a37d-9494f38da6fa.jpg',
  },
  {
    label: 'Talleres plegables',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f99ba6ee-100c-47a3-bae1-65b3a1f3c48d.jpg',
  },
]
